import { useEffect } from 'react';
import { reaction } from 'mobx';
import { useUserSettingsContext } from 'contexts';
import { selectLocalParticipant } from 'state/selectors';
import { roomInfoStore } from 'state/store';
import { stopCameraIfHardLocked } from './webinarStatus';

/** Выключает камеру, когда в настройках вебинара включена блокировка видео. */
export const useWebinarForceCamOff = () => {
    const { setVideoEnabled } = useUserSettingsContext();

    useEffect(
        () =>
            reaction(
                () => ({
                    cameraDisabled: Boolean(roomInfoStore.metadata?.webinarMode?.cameraDisabled),
                    webinarEnabled: Boolean(roomInfoStore.metadata?.webinarMode?.enabled),
                    local: selectLocalParticipant(),
                    isCameraEnabled: selectLocalParticipant()?.isCameraEnabled ?? false,
                }),
                ({ local }) => {
                    if (!local) return;
                    stopCameraIfHardLocked(local, setVideoEnabled);
                },
                { fireImmediately: true },
            ),
        [setVideoEnabled],
    );
};
